// Web shim for react-native-iap.
//
// In-app purchases are a native-only concern (iOS App Store / Google Play).
// On web, all purchase flows go through Whop / Valmar web checkout and every
// react-native-iap call site is guarded behind `Platform.OS` native checks
// (see hooks/useIosIap.js, context/GabPurchaseContext.jsx). The real package
// (~2.7 MB of JS) therefore ships in the web bundle but is never executed.
//
// This shim replaces it on web (wired in metro.config.js → resolveRequest)
// with inert stubs so the bytes drop out of the web `entry-*.js` bundle while
// keeping every imported symbol defined. Native builds are unaffected.

const noopAsync = async () => undefined;
const emptyListAsync = async () => [];

// Listeners return an EmitterSubscription-shaped object so callers can safely
// call `.remove()` even though nothing is ever emitted on web.
const makeSubscription = () => ({ remove() {} });

const setup = () => {};
const initConnection = async () => false;
const endConnection = noopAsync;
const getSubscriptions = emptyListAsync;
const getProducts = emptyListAsync;
const requestSubscription = noopAsync;
const requestPurchase = noopAsync;
const getAvailablePurchases = emptyListAsync;
const getPendingPurchasesIOS = emptyListAsync;
const finishTransaction = noopAsync;
const purchaseUpdatedListener = () => makeSubscription();
const purchaseErrorListener = () => makeSubscription();
const flushFailedPurchasesCachedAsPendingAndroid = noopAsync;
const presentCodeRedemptionSheetIOS = noopAsync;

module.exports = {
  setup,
  initConnection,
  endConnection,
  getSubscriptions,
  getProducts,
  requestSubscription,
  requestPurchase,
  getAvailablePurchases,
  getPendingPurchasesIOS,
  finishTransaction,
  purchaseUpdatedListener,
  purchaseErrorListener,
  flushFailedPurchasesCachedAsPendingAndroid,
  presentCodeRedemptionSheetIOS,
};
